import { BREAK_POINT, BreakPoint } from '@bucketplace/design-system';

import { REBRAND_SIZE, RebrandSizeType } from '../constants';

const DEFAULT_BREAKPOINT = 'mobile';

export function getRebrandStyle<T extends RebrandSizeType>(
  type: T,
  key: keyof typeof REBRAND_SIZE[T][BreakPoint],
  breakPoint: BreakPoint = DEFAULT_BREAKPOINT
): number {
  const size = REBRAND_SIZE[type]?.[breakPoint];

  return size?.[key as keyof typeof size];
}

/** dependencies 우회용 breakpoint 계산 함수 */
export function getBreakPoint(width: number): BreakPoint {
  if (width >= BREAK_POINT.desktop) return 'desktop';
  if (width >= BREAK_POINT.laptop) return 'laptop';
  if (width >= BREAK_POINT.tablet) return 'tablet';
  return 'mobile';
}
